exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-form {\n\n    width: 100%;\n}\n\n.example-full-width {\n    width: 100%;\n}\n\n@media (max-width: 768px) {\n    .body-content {\n        margin-top: 0 !important;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/src/app/online-photo-order/online-photo-order.component.css
// module id = ../../../../../src/app/online-photo-order/online-photo-order.component.css
// module chunks = main